export default "__VITE_ASSET__CToaJrv6__"